import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';

export const batchCustomsForms = {
  id: 'batch-customs-forms',

  getDocumentRequestNotificationProps: (docCount) => ({
    title: <FormattedMessage {...messages.printingCustomsformsTitle} values={{ docCount }} />,
  }),
};
